import * as React from "react";
import { TableWrapper } from "../styles";
import { Alert } from "react-bootstrap";

interface IProps {
    physicianCharges: number,
    anesthesiaCharges: number,
    hospitalCharges: number
}

const StreamlinedBillingService: React.FunctionComponent<IProps> = (props: IProps) => {
    const widths = [10, 20, 20, 20, 20, 10];
    const physicianCharges = props.physicianCharges;
    const anesthesiaCharges = props.anesthesiaCharges;
    const hospitalCharges = props.hospitalCharges;
    const total = physicianCharges + anesthesiaCharges + hospitalCharges;

    return (
        <>
            <div style={{ marginBottom: 10 }}>Streamlined Billing Service</div>

            <ol style={{ listStyle: "decimal", marginBottom: 25 }}>
                <li>
                    <strong>Physician Donor Nephrectomy:</strong>
                    <ol style={{ listStyle: "upper-alpha" }}>
                        <li>If a Member Center is subject to the SBS then the Donor Center shall be reimbursed by the Recipient Center via the NKR according the Standard Reimbursements for the SBS line items unless these costs can be billed to Medicare under CMS guidelines.</li>
                    </ol>
                </li>
                <li style={{ marginTop: 5 }}>
                    <strong>Hospital Donor Nephrectomy:</strong>
                    <ol style={{ listStyle: "upper-alpha" }}>
                        <li>If a Member Center is subject to the SBS then the Donor Center shall be reimbursed by the Recipient Center via the NKR according the Standard Reimbursements for the SBS line items.</li>
                    </ol>
                </li>
            </ol>

            <TableWrapper>
                <thead>
                    <tr>
                        <th></th>
                        <th>Fee</th>
                        <th className='text-center'>Rate</th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td></td>
                        <td>Physician Donor Nephrectomy</td>
                        <td className='text-center'>${physicianCharges.toLocaleString('en')}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>

                    <tr>
                        <td></td>
                        <td>Anesthesia</td>
                        <td className='text-center'>{anesthesiaCharges.toLocaleString('en')}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>

                    <tr>
                        <td></td>
                        <td>Hospital Donor Nephrectomy</td>
                        <td className='text-center'>{hospitalCharges.toLocaleString('en')}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>

                    <tr>
                        <td></td>
                        <td style={{ fontWeight: 500, fontSize: 16, paddingTop: 0, paddingBottom: 0, verticalAlign: 'top' }}><div style={{ paddingTop: 5 }}>Total</div></td>
                        <td style={{ fontWeight: 500, fontSize: 16, paddingTop: 0, paddingBottom: 0, verticalAlign: 'top' }}><div style={{ paddingTop: 5, paddingBottom: 5, marginLeft: 'auto', marginRight: 'auto', width: '50%', borderTop: '1px solid black', borderBottom: '3px double black', textAlign: 'center' }}>${total.toLocaleString('en')}</div></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </TableWrapper>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12" style={{ marginTop: 20 }}>
                        <Alert bsStyle='warning' style={{marginBottom: 0}}>
                            <ul>
                            <li>This exchange involves a center that opted into the Streamlined Billing Service.</li>
                            <li>These charges will be automatically billed to the recipient center by NKR.</li>
                            <li>These funds will be submitted back to your center once received, and to ensure payment to your center please enter the information below</li>
                            </ul>
                        </Alert>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StreamlinedBillingService;